import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function TransitionSection() {
  return <section className="w-full bg-[#F9FAFB] py-16 px-4 sm:px-6 lg:px-8 border-y border-gray-100" data-id="element-370">
      <div className="max-w-2xl mx-auto text-center" data-id="element-371">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="space-y-5" data-id="element-372">
          <p className="text-lg sm:text-xl text-[#1A1A1A] leading-relaxed" data-id="element-373">
            Cuando comprás el{' '}
            <span className="font-bold" data-id="element-374">Mapa 5R: Cierre por DM y WhatsApp</span>
            , no solo te llevás 25 scripts listos para convertir conversaciones
            en ventas.
          </p>
          <p className="text-lg sm:text-xl text-[#1A1A1A] leading-relaxed" data-id="element-375">
            Te llevás también{' '}
            <span className="font-bold text-[#0B6B3A]" data-id="element-376">3 recursos extra</span>{' '}
            diseñados para que el sistema funcione de principio a fin:
          </p>
          <p className="text-xl sm:text-2xl font-bold text-[#1A1A1A] leading-relaxed" data-id="element-377">
            Desde que te escribe un desconocido… hasta que te confirma el pago.
          </p>
          <p className="text-lg text-[#6B7280]" data-id="element-378">
            Sin improvisar en ningún punto.
          </p>
        </motion.div>

        {/* 3 gift icons divider */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mt-12 flex items-center justify-center gap-4" data-id="element-379">
          <div className="flex-1 h-px bg-gray-200" data-id="element-380" />
          <div className="flex items-center gap-3" data-id="element-381">
            <div className="w-10 h-10 rounded-full bg-[#0B6B3A]/10 flex items-center justify-center" data-id="element-382">
              <Gift className="w-5 h-5 text-[#0B6B3A]" data-id="element-383" />
            </div>
            <div className="w-10 h-10 rounded-full bg-[#0B6B3A]/10 flex items-center justify-center" data-id="element-384">
              <Gift className="w-5 h-5 text-[#0B6B3A]" data-id="element-385" />
            </div>
            <div className="w-10 h-10 rounded-full bg-[#0B6B3A]/10 flex items-center justify-center" data-id="element-386">
              <Gift className="w-5 h-5 text-[#0B6B3A]" data-id="element-387" />
            </div>
          </div>
          <div className="flex-1 h-px bg-gray-200" data-id="element-388" />
        </motion.div>
      </div>
    </section>;
}